"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var DomainAPI_1 = require("@src/api/DomainAPI");
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
// Icons & Images
var call_svg_1 = __importDefault(require("@src/components/Icon/call.svg"));
var mic_on_svg_1 = __importDefault(require("@src/components/Icon/mic-on.svg"));
var mic_off_svg_1 = __importDefault(require("@src/components/Icon/mic-off.svg"));
var end_call_svg_1 = __importDefault(require("@src/components/Icon/end-call.svg"));
var end_call_hover_svg_1 = __importDefault(require("@src/components/Icon/end-call-hover.svg"));
var haptik_branding_svg_1 = __importDefault(require("@src/components/Icon/haptik-branding.svg"));
var useVoiceBotCall_1 = __importDefault(require("./hooks/useVoiceBotCall"));
// Styled Components
var StyledComponents_1 = require("./StyledComponents");
var NUM_BARS = 5;
var MIN_HEIGHT = 30;
var MAX_HEIGHT = 140;
var MIN_RING = [1, 1, 1, 1];
var MAX_RING = [1.1, 1.2, 1.3, 1.4];
var MAX_RING_MOBILE = [1.05, 1.1, 1.15, 1.2];
var VoicePage = function () {
    var _a = react_1.useState(null), device = _a[0], setDevice = _a[1];
    var _b = react_1.useState(false), isAuthenticated = _b[0], setIsAuthenticated = _b[1];
    var _c = react_1.useState(''), brandName = _c[0], setBrandName = _c[1];
    var _d = react_1.useState(''), phoneNumber = _d[0], setPhoneNumber = _d[1];
    var _e = react_1.useState(null), incomingConnection = _e[0], setIncomingConnection = _e[1];
    var _f = react_1.useState(null), currentConnection = _f[0], setCurrentConnection = _f[1];
    var _g = react_1.useState(false), inCall = _g[0], setInCall = _g[1];
    var _h = react_1.useState(false), isTwilioLoaded = _h[0], setIsTwilioLoaded = _h[1];
    var _j = react_1.useState(false), active = _j[0], setActive = _j[1];
    var _k = react_1.useState(false), isConnecting = _k[0], setIsConnecting = _k[1];
    var _l = react_1.useState(false), isConnected = _l[0], setIsConnected = _l[1];
    var _m = react_1.useState(false), isEndCallHovered = _m[0], setIsEndCallHovered = _m[1];
    var _o = react_1.useState(false), isMicHovered = _o[0], setIsMicHovered = _o[1];
    var _p = react_1.useState(false), isPrimarySpeaking = _p[0], setIsPrimarySpeaking = _p[1];
    var _q = react_1.useState(true), isLoading = _q[0], setIsLoading = _q[1];
    var _r = react_1.useState(Array(NUM_BARS).fill(MIN_HEIGHT)), heights = _r[0], setHeights = _r[1];
    var _s = react_1.useState(MIN_RING), ringScale = _s[0], setRingScale = _s[1];
    var _t = react_1.useState(''), socketUrl = _t[0], setSocketUrl = _t[1];
    var isDemoPage = window.location.hash.includes('?demo=true') ||
        window.location.hash.includes('/demo') ||
        window.location.hash.includes('&demo=true');
    var isTwilioPage = window.location.hash.includes('?twilio=true') ||
        window.location.hash.includes('&twilio=true');
    var startAnimation = function () { return setActive(true); };
    var stopAnimation = function () {
        setActive(false);
        setHeights(Array(NUM_BARS).fill(MIN_HEIGHT));
        setRingScale([1, 1, 1, 1]);
    };
    var _u = useVoiceBotCall_1["default"](socketUrl, startAnimation, stopAnimation, setIsPrimarySpeaking), isMuted = _u.isMuted, isCalling = _u.isCalling, isCallConnected = _u.isCallConnected, startCall = _u.startCall, stopCall = _u.stopCall, toggleMute = _u.toggleMute;
    var isMobile = window.innerWidth <= 500;
    // Effect to check for Twilio loading
    react_1.useEffect(function () {
        var _a;
        var checkTwilio = function () {
            if (window.Twilio) {
                setIsTwilioLoaded(true);
            }
        };
        if (isTwilioPage)
            checkTwilio();
        var interval = setInterval(checkTwilio, 1000);
        var hashSplitArray = window.location.hash.split('/');
        var domainId = (_a = hashSplitArray[3]) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        // Api call for Haptik Socket connection
        if (!isTwilioPage) {
            DomainAPI_1.getSocketUrl(domainId, false, 'haptik')
                .then(function (res) { return res.json(); })
                .then(function (data) {
                setIsLoading(false);
                setIsAuthenticated(true);
                setSocketUrl(data === null || data === void 0 ? void 0 : data.ws_url);
                setBrandName(data === null || data === void 0 ? void 0 : data.domain_name);
            })["catch"](function (e) {
                console.error('error', e);
            });
        }
        return function () { return clearInterval(interval); };
    }, [window.location.hash]);
    // Twilio initialization
    react_1.useEffect(function () {
        var _a, _b, _c;
        var newDevice;
        if (isTwilioLoaded && isTwilioPage) {
            var hashSplitArray = window.location.hash.split('/');
            var domainId = (_a = hashSplitArray[3]) === null || _a === void 0 ? void 0 : _a.split('?')[0];
            DomainAPI_1.getTwilioToken(((_c = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.id) || domainId, isDemoPage)
                .then(function (res) { return res.json(); })
                .then(function (data) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (data.not_authenticated) {
                        setIsAuthenticated(false);
                        setIsLoading(false);
                        if (phoneNumber)
                            setPhoneNumber('');
                        if (brandName)
                            setBrandName('');
                        return [2 /*return*/];
                    }
                    setIsAuthenticated(true);
                    setPhoneNumber(data === null || data === void 0 ? void 0 : data.phone_number);
                    setBrandName(data === null || data === void 0 ? void 0 : data.botname);
                    newDevice = new window.Twilio.Device(data.token, {
                        codecPreferences: ['opus', 'pcmu'],
                        fakeLocalDTMF: true,
                        enableRingingState: true,
                        debug: true,
                        audioConstraints: {
                            autoGainControl: true,
                            echoCancellation: true,
                            noiseSuppression: true,
                        },
                    });
                    console.log('Device created, registering presence...', newDevice);
                    console.log('Device created, registering presence...', newDevice.state);
                    setTimeout(function () {
                        console.log('Device State after timeout:', newDevice.state);
                    }, 5000);
                    newDevice.on('ready', function () {
                        console.log('Chat App Device is ready');
                        setIsLoading(false);
                    });
                    newDevice.on('registered', function () {
                        console.log('Chat App Device is ready for incoming calls');
                    });
                    newDevice.on('registering', function () {
                        console.log('Chat App Device is registering...');
                    });
                    newDevice.on('error', function (error) {
                        console.error('Device error:', error);
                        setIsConnecting(false);
                    });
                    newDevice.on('connect', function (connection) {
                        console.log('Connected', connection);
                        setIsConnecting(false);
                        setIsConnected(true);
                    });
                    newDevice.on('disconnect', function () {
                        console.log('🚨 Call Disconnected Before Answering');
                        setIsConnected(false);
                        setIncomingConnection(null);
                        setInCall(false);
                        setCurrentConnection(null);
                        setIsConnecting(false);
                    });
                    newDevice.on('cancel', function () {
                        console.log('Call canceled');
                        setIsConnecting(false);
                    });
                    newDevice.on('reject', function () {
                        console.log('Call rejected');
                        setIsConnecting(false);
                    });
                    newDevice.on('incoming', function (connection) {
                        var To = connection.parameters.To;
                        console.log('Incoming call for:', To, data);
                        setIncomingConnection(connection);
                        connection.on('disconnect', function () {
                            console.log('🚨 Call Disconnected Before Answering');
                            setIncomingConnection(null);
                            setInCall(false);
                        });
                        connection.on('cancel', function () {
                            console.log('❌ Call was canceled before being answered');
                            setIncomingConnection(null);
                            setInCall(false);
                        });
                    });
                    newDevice.on('disconnect', function () {
                        setIncomingConnection(null);
                        setCurrentConnection(null);
                        setIsConnected(false);
                    });
                    console.log({ newDevice: newDevice });
                    if (newDevice)
                        setDevice(newDevice);
                    return [2 /*return*/];
                });
            }); })["catch"](function (error) { return console.error('Error fetching token:', error); });
        }
        return function () {
            if (newDevice)
                newDevice.destroy();
            console.log('Device destroyed');
        };
    }, [isTwilioLoaded, window.location.hash]);
    // Bar animations
    react_1.useEffect(function () {
        var interval;
        if (active) {
            interval = setInterval(function () {
                var newHeights = Array.from({ length: NUM_BARS }, function () {
                    return Math.floor(Math.random() * (MAX_HEIGHT - MIN_HEIGHT)) + MIN_HEIGHT;
                });
                setHeights(newHeights);
            }, 100);
        }
        return function () { return clearInterval(interval); };
    }, [active]);
    // Ring animations
    react_1.useEffect(function () {
        var interval;
        if (active) {
            interval = setInterval(function () {
                setRingScale(isMobile ? MAX_RING_MOBILE : MAX_RING);
            }, 100);
        }
        return function () { return clearInterval(interval); };
    }, [active]);
    var notConnectedUI = isConnecting || (isCalling && !isCallConnected) ? (react_1["default"].createElement(text_1["default"], { color: "background", style: { fontSize: '36px', fontWeight: '500' } }, "Connecting...")) : (react_1["default"].createElement(call_svg_1["default"], null));
    var mutedState = isMicHovered ? react_1["default"].createElement(mic_on_svg_1["default"], null) : react_1["default"].createElement(mic_off_svg_1["default"], null);
    var renderCenterUI = function () {
        return isAuthenticated ? (react_1["default"].createElement(StyledComponents_1.CallWrapper, { padding: "0", isConnecting: isConnecting, inCall: !!currentConnection },
            react_1["default"].createElement(box_1["default"], { style: {
                    position: 'relative',
                    cursor: isConnected ? 'default' : 'pointer',
                    width: isMobile ? '100vw' : '400px',
                    height: '70%',
                    aspectRatio: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'visible',
                }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var params, outgoingConnection;
                    return __generator(this, function (_a) {
                        if (!isTwilioPage) {
                            startCall();
                        }
                        else {
                            params = {
                                To: phoneNumber,
                            };
                            if (device && !isConnected) {
                                outgoingConnection = device.connect(params);
                                setCurrentConnection(outgoingConnection);
                                outgoingConnection.on('ringing', function () {
                                    console.log('Ringing...');
                                    setIsConnecting(true);
                                });
                                outgoingConnection.on('volume', function (inputVolume, outputVolume) {
                                    if (outputVolume > 0.05) {
                                        startAnimation();
                                    }
                                    else {
                                        stopAnimation();
                                    }
                                    if (inputVolume > 0.1) {
                                        setIsPrimarySpeaking(true);
                                    }
                                    else {
                                        setIsPrimarySpeaking(false);
                                    }
                                });
                            }
                        }
                        return [2 /*return*/];
                    });
                }); } },
                react_1["default"].createElement(box_1["default"], { style: {
                        width: isMobile ? '100vw' : '400px',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden',
                    } },
                    react_1["default"].createElement(StyledComponents_1.CenterImage, { src: "https://tools-cdn.s3.ap-south-1.amazonaws.com/platform/assets/voice_ui_center.png", alt: "Call Icon" })),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring1", isConnecting: isConnecting, ringScale: ringScale[0] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring2", isConnecting: isConnecting, ringScale: ringScale[1] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring3", isConnecting: isConnecting, ringScale: ringScale[2] }),
                react_1["default"].createElement(StyledComponents_1.Ring, { className: "ring ring4", isConnecting: isConnecting, ringScale: ringScale[3] }),
                react_1["default"].createElement(box_1["default"], { style: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '10',
                        backgroundColor: 'transparent',
                    } }, isConnected || (isCalling && isCallConnected) ? (react_1["default"].createElement(StyledComponents_1.BarContainer, null, heights.map(function (height, index) { return (react_1["default"].createElement(StyledComponents_1.Bar, { key: index, height: height })); }))) : (notConnectedUI))),
            (currentConnection || isCallConnected) && (react_1["default"].createElement(StyledComponents_1.ControlBox, { isPrimarySpeaking: isPrimarySpeaking },
                react_1["default"].createElement(box_1["default"], { padding: "0", width: "70px", height: "70px", style: {
                        cursor: 'pointer',
                        display: 'inline-block',
                        boxShadow: isPrimarySpeaking
                            ? '0 0 20px 10px rgba(0, 62, 135, 0.9)'
                            : '0 0 20px 5px rgba(127, 215, 255, 0.3)',
                        transition: 'box-shadow 0.5s ease-in-out',
                        borderRadius: '50%',
                    }, onMouseEnter: function () { return setIsMicHovered(true); }, onMouseLeave: function () { return setIsMicHovered(false); }, onClick: function () {
                        if (!isTwilioPage) {
                            toggleMute();
                        }
                        if (currentConnection) {
                            var newMute = !currentConnection.isMuted();
                            currentConnection.mute(newMute);
                        }
                    } }, (currentConnection && currentConnection.isMuted()) || isMuted ? (mutedState) : (react_1["default"].createElement(mic_on_svg_1["default"], null))),
                react_1["default"].createElement(box_1["default"], { padding: "0", width: "70px", height: "70px", style: { cursor: 'pointer', display: 'inline-block' }, onMouseEnter: function () { return setIsEndCallHovered(true); }, onMouseLeave: function () { return setIsEndCallHovered(false); }, onClick: function () {
                        if (!isTwilioPage) {
                            stopCall();
                        }
                        else
                            currentConnection === null || currentConnection === void 0 ? void 0 : currentConnection.disconnect();
                        stopAnimation();
                    } }, isEndCallHovered ? react_1["default"].createElement(end_call_hover_svg_1["default"], null) : react_1["default"].createElement(end_call_svg_1["default"], null)))))) : (react_1["default"].createElement(box_1["default"], { padding: "0", style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                flexDirection: 'column',
                textAlign: 'center',
                backgroundColor: 'transparent',
            } },
            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "background" }, "Access Denied"),
            react_1["default"].createElement(text_1["default"], { varaint: "body.md", color: "background" }, "You do not have permission to view this page. Please log in or use a valid access link.")));
    };
    return (react_1["default"].createElement(box_1["default"], { width: "100%", height: "100%", flexDirection: "column", padding: "0", style: {
            backgroundColor: '#003C82',
            boxSizing: 'border-box',
            backgroundImage: 'linear-gradient(to right, #144c8e 1px, transparent 1px),linear-gradient(to bottom, #144c8e 1px, transparent 1px)',
            backgroundSize: '40px 40px',
        } },
        react_1["default"].createElement(box_1["default"], { padding: isMobile ? '12px' : '20px 95px', height: "110px", justifyContent: "space-between", alignItems: "center", style: { boxSizing: 'border-box', backgroundColor: 'transparent' } },
            react_1["default"].createElement(box_1["default"], { padding: 0, maxWidth: isMobile && '35%' },
                react_1["default"].createElement(haptik_branding_svg_1["default"], null)),
            brandName && (react_1["default"].createElement(text_1["default"], { color: "#FFFFFFB2", style: {
                    fontSize: isMobile ? '20px' : '22px',
                    fontWeight: '600',
                    maxWidth: '45%',
                    wordWrap: 'break-word',
                } }, brandName))),
        isLoading ? (react_1["default"].createElement(StyledComponents_1.StyledLoader, { themed: true, size: "52", color: "#fff" })) : (renderCenterUI())));
};
exports["default"] = VoicePage;
